export const polarToCartesianCoordinates = <T extends number>(
  cX: T,
  cY: T,
  rad: T,
  angleInDegrees: T
) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: cX + rad * Math.cos(angleInRadians),
    y: cY + rad * Math.sin(angleInRadians),
  };
};

export const pathForSemiCircularSvg = <T extends number>(
  x: T,
  y: T,
  rad: T,
  startAngle: T,
  endAngle: T
) => {
  const start = polarToCartesianCoordinates(x, y, rad, endAngle);
  const end = polarToCartesianCoordinates(x, y, rad, startAngle);

  const path = [
    `M ${start.x} ${start.y}`,
    `A ${rad} ${rad} 0 ${endAngle - startAngle <= 180 ? '0' : '1'} 0 ${end.x} ${
      end.y
    }`,
  ].join(' ');

  return path;
};

export const getPercentage = (
  value: number | undefined,
  shouldShowZero: boolean | undefined
) => {
  if (value) {
    return Math.min(100, Math.max(0, value));
  }

  if (shouldShowZero) {
    return 0;
  }

  return '-';
};
